/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import ResponsiveAppBar from 'app/components/Navbar';
import PersistentDrawerLeft from 'app/components/Drawer';
import { isFullScreenRoute, isShowDrawerRoute } from 'app/utils/route';
import { AppLoader } from 'components/loader/AppLoader';
import useIsDashbord from 'hooks/useIsDashbord';
import { getContentBackground } from 'app/utils/ColorContext';
import { useTheme } from '@mui/material/styles';
import './scroll.css';

function AppWrapper() {
    const theme = useTheme();
    const location = useLocation();
    const params = useParams();
    const [path, setPath] = useState('');
    const isDashbord = useIsDashbord();
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, [mobileOpen]);

    useEffect(() => {
        if (location.pathname) {
            if (params.id) {
                setPath(location.pathname.replace(`/${params.id}`, ''));
            } else {
                setPath(location.pathname);
            }
        }
    }, [location]);

    return (
        <>
            {!isDashbord && <AppLoader />}
            <Box sx={styles.wrapper}>
                <CssBaseline />
                {!isFullScreenRoute(path) ? (
                    <PersistentDrawerLeft
                        isOpen={mobileOpen}
                        drawerToggle={handleDrawerToggle}
                    />
                ) : isShowDrawerRoute(path) ? (
                    <PersistentDrawerLeft
                        isOpen={mobileOpen}
                        drawerToggle={handleDrawerToggle}
                    />
                ) : null}

                <Box sx={styles.rightBox}>
                    {!isFullScreenRoute(path) && (
                        <ResponsiveAppBar drawerToggle={handleDrawerToggle} />
                    )}
                    {/* {!isFullScreenRoute(path) ? (
            <>
              <ResponsiveAppBar drawerToggle={handleDrawerToggle} />
              {/* <PersistentDrawerLeft
                isOpen={mobileOpen}
                drawerToggle={handleDrawerToggle}
              /> */}
                    {/* </>
          ) : isShowDrawerRoute(path) ? (
            <PersistentDrawerLeft />
          ) : null} */}
                    <Box
                        component="main"
                        id="appConainter"
                        sx={{
                            ...styles.outlet,
                            bgcolor: getContentBackground(theme),
                        }}
                    >
                        <Outlet />
                    </Box>
                </Box>
            </Box>
        </>
    );
}

const styles = {
    wrapper: {
        display: 'flex',
        width: '100%',
        bgcolor: 'background.default',
        color: 'text.primary',
        borderRadius: 1,
        height: 'calc(97vh - 1em)',
        overflow: 'auto',
    },
    outlet: {
        flexGrow: 1,
        overflow: 'auto',
    },
    rightBox: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        overflow: 'hidden',
    },
};

export default AppWrapper;
